import React from 'react'
import PropTypes from 'prop-types'

const Header = (props) => (
    <header id="header" style={props.timeout ? {display: 'none'} : {}}>
        <div className="logo">
            <span className="icon fa-diamond"></span>
        </div>
        <div className="content">
            <div className="inner">
                <h1>Nucleation Rate Calculators</h1>
                {/*<p>Unary Homogeneous Nucleation (UHN) of H<sub>2</sub>O</p>*/}
                <p>Binary Homogeneous Nucleation (BHN) of H<sub>2</sub>SO<sub>4</sub>-H<sub>2</sub>O</p>
                <p>Ternary Homogeneous Nucleation (THN) of H<sub>2</sub>SO<sub>4</sub>-H<sub>2</sub>O-NH<sub>3</sub></p>
                <p>Binary Ion-Mediated Nucleation (BIMN) of H<sub>2</sub>SO<sub>4</sub>-H<sub>2</sub>O</p>
                <p>Ternary Ion-Mediated Nucleation (TIMN) of H<sub>2</sub>SO<sub>4</sub>-H<sub>2</sub>O-NH<sub>3</sub></p>
            </div>
        </div>
        <nav>
            <ul>
                {/*<li><a href="javascript:;" onClick={() => {props.onOpenArticle('uhn')}}>UHN</a></li>*/}
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('bhn')}}>BHN</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('thn')}}>THN</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('bimn')}}>BIMN</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('timn')}}>TIMN</a></li>

                {/* <li><a href="javascript:;" onClick={() => {props.onOpenArticle('contact')}}>Contact</a></li> */}
            </ul>
        </nav>
        <div className="content">
            <div className="inner">
                <h4 style={{color:"red"}}>(Current Browser Support: Safari, Chrome, Firefox, MS Edge)</h4>
            </div>
        </div>
    </header>
)

Header.propTypes = {
    onOpenArticle: PropTypes.func,
    timeout: PropTypes.bool
}

export default Header
